<template>
  <div class="card">
    <div
      v-b-toggle="`collapseManagerial`"
      class="card-header"
    >
      <h3
        :id="`field-5`"
        class="cart-title"
      >
        <a data-action="collapse">{{ field.label ? field.label : field.name }}</a>
      </h3>
      <b-tooltip
        :key="`field-custom-5`"
        placement="topleft"
        boundary="document"
        triggers="hover"
        :target="`field-5`"
        :title="field.tooltip"
      />
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a data-action="collapse"><i data-feather="chevron-down" /></a>
          </li>
          <!-- <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
              @click="redirectuser($event, [{user_id: userId}, 'researcher.managerial.index'])"
            ><i data-feather="edit-3" /></a>
          </li> -->
        </ul>
      </div>
    </div>
    <b-collapse
      :id="`collapseManagerial`"
      v-model="isToggled"
    >
      <div
        class="card-content"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="row"
          >
            <div class="col">
              <div v-if="fromPromotion && convo.days > 0 && isResearcher" class="mb-2">
                <div class="form-check form-switch form-check-inline me-2">
                  <input id="selectAllManagerials" class="form-check-input" type="checkbox" :checked="allManagerialsSelected" @change="toggleSelectAllManagerials">
                  <label class="form-check-label" for="selectAllManagerials">Select all</label>
                </div>
              </div>
              <hr>
              <ul
                v-for="managerial in filteredManagerials"
                :key="managerial.id"
                class="abridged-cv__list"
              >
                <li>
                  <div
                    v-if="fromPromotion && convo.days > 0 && isResearcher"
                    class="form-check form-switch form-check-inline me-2"
                  >
                    <input
                      :id="'activityContent' + managerial.id"
                      type="checkbox"
                      class="form-check-input"
                      :checked="selectedActivities.includes(managerial.id.toString())"
                      @change="handleActivityClick(managerial, $event)"
                    >
                  </div>
                  <strong>{{ managerial.date_formatted }} - {{ managerial.end_date_formatted }}</strong> ·
                  {{ managerial.content_formatted.managerial_type ? `(${managerial.content_formatted.managerial_type.name})` : (managerial.content_formatted.managerial_type_name ? `(${managerial.content_formatted.managerial_type_name})` : '') }}. {{ managerial.content_formatted.title }} {{ managerial.content_formatted.virtual_activity ? '(online)' : '' }}
                  <a
                    class="ms-1 btn btn-sm bg-light-secondary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit"
                    @click="redirectuser($event, [{ id: managerial.id }, 'researcher.managerial.edit'])"
                  ><i data-feather="edit-3" /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCollapse, BTooltip } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
    BTooltip,
  },
  props: {
    userId: { type: Number, required: true, default: () => {} },
    yearBetween: { type: Object, required: true, default: () => {} },
    field: { type: Object, required: true },
    promo: { type: Object, required: false, default: () => {} },
    fromPromotion: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      loading: true,
      isToggled: true,
      type: 'managerial',
      optimisticSelectedActivities: new Set(),
    }
  },
  computed: {
    ...mapGetters({
      scientificManagerials: 'users/scientificManagerials',
      selectedActivities: 'convo/selectedActivities',
      toggled: 'preview/toggled',
      convo: 'convo/convo',
      loggedUser: 'auth/admin',
    }),
    isResearcher() {
      return this.loggedUser.roles.includes('researcher')
    },
      visibleManagerials() {
        return (this.filteredManagerials || []).map(m => m)
      },
      visibleManagerialIds() {
        return this.visibleManagerials.map(m => m.id?.toString()).filter(Boolean)
      },
      allManagerialsSelected() {
        const ids = this.visibleManagerialIds
        return ids.length > 0 && ids.every(id => this.selectedActivities.includes(id) || this.optimisticSelectedActivities.has(id))
      },
    filteredManagerials() {
      if (this.loggedUser.roles.includes('super-admin') && (!this.fromPromotion || this.convo.year < 2026)) {
        return this.scientificManagerials
      }
      if (this.isResearcher && (!this.fromPromotion || this.convo.days > 0)) {
        return this.scientificManagerials
      }
      // For non-researchers or when in promotion mode with days <= 0, only show selected managerial activities
      return this.scientificManagerials.filter(managerial => this.selectedActivities.includes(managerial.id.toString()))
    },
  },
  watch: {
    userId() {
      this.reloadData()
    },
    toggled() {
      if (this.toggled !== this.isToggled) {
        this.isToggled = this.toggled
      }
    },
    yearBetween() {
      this.reloadData()
    },
    selectedActivities() {
      this.optimisticSelectedActivities = new Set()
    },
  },
  async mounted() {
    this.reloadData()
    if (this.fromPromotion) {
      this.loadSelectedActivities()
    }
  },
  methods: {
    async reloadData() {
      this.loading = true
      this.isToggled = this.toggled
      if (this.promo && this.promo.id && !this.promo.active_researcher) {
        await this.$store.dispatch('users/fetchUserScientificActivitiesFreezed', {
          convo: this.promo.id, userId: this.userId, yearBetween: this.yearBetween, type: this.type,
        })
      } else {
        await this.$store.dispatch('users/fetchUserScientificActivities', { userId: this.userId, yearBetween: this.yearBetween, type: this.type })
      }
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 500)
      this.loading = false
    },
    async redirectuser(event, redirection) {
      event.stopPropagation()
      this.$emit('goToIndex', redirection)
    },

    handleActivityClick(activity, event) {
      const isChecked = event.target.checked
      const isCurrentlySelected = this.selectedActivities.includes(activity.id.toString())
      const promotionDataId = isCurrentlySelected ? activity.pivot?.id : null

      this.$emit('item-selected', {
        id: promotionDataId || null,
        origenable_id: activity.id,
        type: 'App\\Models\\Activity',
        selected: isChecked,
      })
    },

    toggleSelectAllManagerials() {
      const allSelected = this.allManagerialsSelected
      for (const activity of this.filteredManagerials || []) {
        this.$emit('item-selected', {
          id: allSelected ? (activity.pivot?.id || null) : null,
          origenable_id: activity.id,
          type: 'App\\Models\\Activity',
          selected: !allSelected,
        })
      }
      if (!allSelected) {
        this.optimisticSelectedActivities = new Set(this.visibleManagerialIds)
      } else {
        this.optimisticSelectedActivities = new Set()
      }

      setTimeout(async () => {
        await this.loadSelectedActivities()
      }, 1000)
    },

    async loadSelectedActivities() {
      if (!this.fromPromotion) return

      try {
        await this.$store.dispatch('convo/fetchSelectedPromotionScientificProductions', {
          origenableType: 'App\\Models\\Activity',
          userId: this.userId,
        })
      } catch (error) {
        console.error('Error loading selected activities:', error)
      }
    },
  },
}
</script>
